export const routes = {
  TERMS: '/terms-and-conditions',
};
